import { useCallback, useEffect, useMemo, useState } from 'react';

import useAppSelector from '../useAppSelector';
import { selectBridgeSlice } from '../../redux/slices/bridgeSlice';
import { formatTokenAmount } from '../../utils/common';
import { TokenSymbol } from '../../datas/tokens';
import useTokensInitialData from '../queries/useTokenInitialData';
import { ConvertAmountRangeRes } from '../../apis/bridgeAPI/cryptocurrency/types';

const useMaxAmountOfTokens = (type: 'all' | TokenSymbol) => {
  const [tokenList, setTokenList] = useState<ConvertAmountRangeRes[]>([]);
  const { tokens } = useAppSelector(selectBridgeSlice);
  const tokensInitialData = useTokensInitialData();

  const setMaxAmountOfTokens = useCallback(async () => {
    const amountRangeOfTokens = tokens
      .map((localToken) =>
        tokensInitialData?.find((serverToken) => {
          return type === `all`
            ? serverToken.symbol === localToken.symbol
            : serverToken.symbol === localToken.symbol &&
                serverToken.symbol === type;
        }),
      )
      .filter((token) => token) as ConvertAmountRangeRes[];

    setTokenList(amountRangeOfTokens ?? []);
    return null;
  }, [tokens, tokensInitialData, type]);

  const tokenConvertToString = useMemo(
    () =>
      tokenList.map((token, idx) => {
        return ` ${formatTokenAmount(token.maxAmount)} ${token.symbol}${
          idx !== tokenList.length - 1 ? ` /` : ` `
        }`;
      }),
    [tokenList],
  );

  useEffect(() => {
    setMaxAmountOfTokens();
  }, [setMaxAmountOfTokens]);

  return tokenConvertToString;
};

export default useMaxAmountOfTokens;
